import _defineProperty from "/var/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/var/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["slide"],
    _excluded2 = ["render", "video"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from "react";
import { VideoSlide } from "./VideoSlide.js";
export var defaultVideoProps = {
  controls: true,
  playsInline: true
};
export var Video = function Video(_ref) {
  var augment = _ref.augment;
  augment(function (_ref2) {
    var _ref2$render = _ref2.render,
        renderSlide = _ref2$render.slide,
        restRender = _objectWithoutProperties(_ref2$render, _excluded),
        originalVideo = _ref2.video,
        restProps = _objectWithoutProperties(_ref2, _excluded2);

    return _objectSpread({
      render: _objectSpread({
        slide: function slide(_slide, offset, rect) {
          if (_slide.type === "video") {
            return React.createElement(VideoSlide, {
              key: "".concat(_slide.sources.map(function (source) {
                return source.src;
              }).join(" ")),
              slide: _slide,
              offset: offset
            });
          }

          return renderSlide === null || renderSlide === void 0 ? void 0 : renderSlide(_slide, offset, rect);
        }
      }, restRender),
      video: _objectSpread(_objectSpread({}, defaultVideoProps), originalVideo)
    }, restProps);
  });
};